import { FormattedMessage } from 'react-intl'

import { Button } from '@gto/ui/button'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

import { useSupportLinks } from '@/components/support-links'
import type { Translations } from '@/localise'

export const SupportLinksCard = ({
  titleTKey = 'common.labels.needAdditionalSupport',
}: {
  titleTKey?: keyof Translations
}) => {
  return (
    <div className="flex flex-col items-start sm:items-stretch sm:gap-8">
      <Typography
        gutterBottom
        className="text-left font-semibold sm:text-center"
        color="text.primary"
        component="h3"
        variant="h6"
      >
        <FormattedMessage
          id={titleTKey}
          values={{
            highlight: (chunks) => (
              <Typography
                className="font-semibold [font-size:inherit]"
                color="primary"
                component="span"
              >
                {chunks}
              </Typography>
            ),
          }}
        />
      </Typography>
      <Paper
        className="rounded-md border border-divider p-6"
        elevation="4"
      >
        <div className="m-0 flex w-auto flex-row flex-wrap items-center justify-start gap-2 sm:mx-auto sm:my-0 sm:w-full sm:flex-col sm:items-stretch sm:gap-4">
          {useSupportLinks().map((link) => (
            <Button
              key={link.gaTag}
              aria-label={link['aria-label']}
              color="secondary"
              href={link.href}
              rel={link.rel}
              size="large"
              startIcon={link.icon}
              target={link.target}
              variant="contained"
            >
              {link.label}
            </Button>
          ))}
        </div>
      </Paper>
    </div>
  )
}
